import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import UserLogin from './pages/user-login';
import AgentDashboard from './pages/agent-dashboard';
import PropertyCreation from './pages/property-creation';
import OfferManagement from './pages/offer-management';
import UserRegistration from './pages/user-registration';
import ReportGeneration from './pages/report-generation';
import BillingDashboard from './pages/billing-dashboard';
import AccountSettings from './pages/account-settings';
import ForgotPassword from './pages/forgot-password';
import PasswordReset from './pages/password-reset';
import AdminDashboard from './pages/admin-dashboard';
import PaymentMonitoringDashboard from './pages/payment-monitoring-dashboard';
import AboutOfferSenseAI from './pages/about-offer-sense-ai';
import AboutOfferSenseAILoggedIn from './pages/about-offer-sense-ai-logged-in';
import { AuthProvider } from './contexts/AuthContext';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<UserLogin />} />
          <Route path="/user-login" element={<UserLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/agent-dashboard" element={<AgentDashboard />} />
          <Route path="/property-creation" element={<PropertyCreation />} />
          <Route path="/offer-management" element={<OfferManagement />} />
          <Route path="/user-registration" element={<UserRegistration />} />
          <Route path="/report-generation" element={<ReportGeneration />} />
          <Route path="/account" element={<AccountSettings />} />
          <Route path="/billing-dashboard" element={<BillingDashboard />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/payment-monitoring-dashboard" element={<PaymentMonitoringDashboard />} />
          <Route path="/about" element={<AboutOfferSenseAI />} />
          <Route path="/about-offer-sense-ai-logged-in" element={<AboutOfferSenseAILoggedIn />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
